var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.665 1.859a1.089 1.089 0 00-1.54-1.54L.32 6.125a1.089 1.089 0 000 1.54l5.806 5.806a1.089 1.089 0 101.54-1.54L2.628 6.896 7.665 1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.411 5.806H1.09a1.089 1.089 0 000 2.178H21.41a1.089 1.089 0 100-2.178z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.7024d18f.svg";
export { ForwardRef as ReactComponent };